import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useBasePath } from '~/common/hooks/useBasePath';
import { cn } from '~/common/utils/styleUtil';

type CatalogAghArticleNotAvailableProps = {
  status: string;
  showArticleNotAvailable: boolean;
  substituteArticleNumber?: string;
  substituteArticleText?: string;
};

export function CatalogAghArticleNotAvailable({
  status,
  showArticleNotAvailable,
  substituteArticleNumber,
  substituteArticleText
}: Readonly<CatalogAghArticleNotAvailableProps>) {
  const { t } = useTranslation();
  const { path } = useBasePath();

  if (status === 'a') {
    return null;
  }

  let text = '';
  const statusB = status === 'b';
  if (statusB) {
    text = t('Bestellartikel. Verfügbarkeit nicht garantiert');
  }

  if (showArticleNotAvailable) {
    text = t('Der Artikel ist nicht mehr verfügbar');
  }

  return (
    <div
      className={cn(
        'border rounded w-full p-2 text-white text-sm flex flex-wrap gap-1 flex-col desktop:flex-row mt-4',
        showArticleNotAvailable && 'bg-primary',
        statusB && 'text-secondary border-secondary'
      )}
      data-testid={'article-not-available-text'}
    >
      <div className="flex gap-2">
        <p>{text}</p>
      </div>
      {showArticleNotAvailable && substituteArticleNumber && (
        <div className={'flex flex-wrap'}>
          <span>{t('Ersatzartikel')}:</span>&nbsp;
          <Link
            className={'underline'}
            to={`${path}/catalog/article/${substituteArticleNumber}`}
            data-testid={'substitute-article-link'}
          >
            <p className={'line-clamp-1'}>
              {substituteArticleNumber}&nbsp;{substituteArticleText}
            </p>
          </Link>
        </div>
      )}
    </div>
  );
}
